import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { AvatarCatalogEntry } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface CatalogData {
  catalog: AvatarCatalogEntry[]
}

export const fetchAvatarCatalog = async (workspaceId: number, brandKitId: number) => {
  const res = await sendToApi<CatalogData>(`/w/${workspaceId}/brand_kits/${brandKitId}/avatars/catalog`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to fetch avatar catalog')
  }
  return res.data
}

export const useAvatarCatalog = (
  { brandKitId }: { brandKitId?: number },
  options?: UseQueryOptions<AvatarCatalogEntry[]>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<AvatarCatalogEntry[]>(
    ['workspaces', workspaceId, 'brandKits', brandKitId, 'avatars', 'catalog'],
    async () => {
      if (!brandKitId) throw new Error('brandKitId is required')
      const data = await fetchAvatarCatalog(workspaceId, brandKitId)
      return data?.catalog ?? []
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: !!brandKitId,
      ...options,
    },
  )
}
